import { ContentBlock } from "../types/courseBlocks";

export interface HeadingEntry {
  id: string;
  text: string;
  level: number;
}

export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

/**
 * Pulls the markdown headings (# / ## / ###) out of a module's text blocks,
 * in document order, with deduplicated slug ids. Called independently by
 * the sidebar (to build the table of contents) and by BlockRenderer (to
 * assign matching ids to the rendered headings) — both are pure functions
 * over the same block array, so the ids always line up.
 */
export const extractHeadings = (blocks: ContentBlock[]): HeadingEntry[] => {
  const headings: HeadingEntry[] = [];
  const seen = new Map<string, number>();

  blocks.forEach((block) => {
    if (block.type !== "text") return;
    block.markdown.split("\n").forEach((line) => {
      const match = /^(#{1,4})\s+(.+)$/.exec(line.trim());
      if (!match) return;
      const level = match[1].length;
      const text = match[2].trim();
      const base = slugify(text) || "section";
      const count = seen.get(base) || 0;
      seen.set(base, count + 1);
      headings.push({ id: count === 0 ? base : `${base}-${count}`, text, level });
    });
  });

  return headings;
};
